/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceGameEnabledActivityTypes } from './SurfaceGameEnabledActivityTypes';
import {
    SurfaceGameEnabledActivityTypesFromJSON,
    SurfaceGameEnabledActivityTypesFromJSONTyped,
    SurfaceGameEnabledActivityTypesToJSON,
    SurfaceGameEnabledActivityTypesToJSONTyped,
} from './SurfaceGameEnabledActivityTypes';

/**
 * 
 * @export
 * @interface SurfaceAllowedGame
 */
export interface SurfaceAllowedGame {
    /**
     * OWGame ID
     * @type {string}
     * @memberof SurfaceAllowedGame
     */
    gameId: string;
    /**
     * 
     * @type {SurfaceGameEnabledActivityTypes}
     * @memberof SurfaceAllowedGame
     */
    enabledActivityTypes: SurfaceGameEnabledActivityTypes;
}

/**
 * Check if a given object implements the SurfaceAllowedGame interface.
 */
export function instanceOfSurfaceAllowedGame(value: object): value is SurfaceAllowedGame {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('enabledActivityTypes' in value) || value['enabledActivityTypes'] === undefined) return false;
    return true;
}

export function SurfaceAllowedGameFromJSON(json: any): SurfaceAllowedGame {
    return SurfaceAllowedGameFromJSONTyped(json, false);
}

export function SurfaceAllowedGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceAllowedGame {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'enabledActivityTypes': SurfaceGameEnabledActivityTypesFromJSON(json['enabledActivityTypes']),
    };
}

export function SurfaceAllowedGameToJSON(json: any): SurfaceAllowedGame {
    return SurfaceAllowedGameToJSONTyped(json, false);
}

export function SurfaceAllowedGameToJSONTyped(value?: SurfaceAllowedGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'enabledActivityTypes': SurfaceGameEnabledActivityTypesToJSON(value['enabledActivityTypes']),
    };
}

